angular.module('routes.globalreports.GlobalReportsPayloadResolver', [
  'stack'
])

/**
 * The GlobalReportsPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class GlobalReportsPayloadResolver
 * @constructor
 * @module routes.globalreports.GlobalReportsPayloadResolver
 */
.factory('GlobalReportsPayloadResolver', [
  function () {
    'use strict';

    return function () {
      return true;
    };
  }
]);
